import {NgModule} from "@angular/core";
import {CustomUserEventBuilder} from "./custom-user-event.builder";

@NgModule({})
export class CustomUserEventModule {
  // tslint:disable-next-line:variable-name
  constructor(_customUserEventBuilder: CustomUserEventBuilder) {}
}
